import { useDispatch } from 'react-redux'

export const useThunkDispatch = () => useDispatch()
